<ng-container *ngIf="useMatInput; else plainInput">
  <mat-form-field [class.full-width]="fullWidth">
    <input
      matInput
      placeholder="{{ placeholder }}"
      [matAutocomplete]="autoComplete"
      [formControl]="autoCompleteInput"
    />
    <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  </mat-form-field>
</ng-container>
<ng-template #plainInput>
  <input
    class="input-control"
    placeholder="{{ placeholder }}"
    [matAutocomplete]="autoComplete"
    [formControl]="autoCompleteInput"
  />
</ng-template>
<mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFn">
  <mat-option *ngFor="let option of options" [value]="option">
    <span *ngIf="displayLabel(option) as display" title="{{ display }}">{{ display }}</span>
  </mat-option>
</mat-autocomplete>
